import loadScript from 'source/lib/loaders/script';

export default async function loadOneTrust({ domainId, autoblockEnabled } = {}) {
    if (domainId) {
        if (autoblockEnabled) {
            await loadScript(`https://cdn.cookielaw.org/consent/${domainId}/OtAutoBlock.js`,
                { noCatch: true });
        }
        await loadScript('https://cdn.cookielaw.org/scripttemplates/otSDKStub.js', {
            attributes: [
                ['data-document-language', 'true'],
                ['data-domain-script', domainId],
                ['charset', 'UTF-8'],
            ],
        });
        window.OptanonWrapper = function OptanonWrapper() {
        };
    }
}

export async function getOneTrustGeoCountry() {
    return new Promise((resolve, reject) => {
        const CHECK_DELAY = 30;
        const MAX_TRIES = 1000;

        let checkCount = 0;
        const checkId = setInterval(() => {
            const oneTrustReady = window.OneTrust && window.OneTrust.getGeolocationData;

            if (oneTrustReady) {
                let OTCountry;
                try {
                    OTCountry = window.OneTrust.getGeolocationData().country;
                } catch (e) {
                    console.error(e);
                }

                if (!OTCountry) {
                    clearInterval(checkId);
                    reject(new Error('Unable to get onetrust geo country'));
                    return;
                }

                clearInterval(checkId);
                resolve(OTCountry);
                return;
            }

            checkCount += 1;
            if (checkCount > MAX_TRIES) {
                clearInterval(checkId);
                reject(new Error('Loading one trust timeout'));
            }
        }, CHECK_DELAY);
    });
}
